"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportBudgetToExcel = void 0;
var collectionsRef_1 = require("common/db/collectionsRef");
var budgetLinesList_1 = require("common/global/budgetLinesList");
var budgetSectionsList_1 = require("common/global/budgetSectionsList");
var projectsList_1 = require("common/global/projectsList");
var unitsList_1 = require("common/global/unitsList");
var lodash_1 = require("lodash");
var xlsx_1 = __importDefault(require("xlsx"));
var exportBudgetToExcel = function (projectId) { return __awaiter(void 0, void 0, void 0, function () {
    var sectionFields, sectionTitles, linesFields, linesTitles, lineItemsFields, lineItemsTitles, sectionsData, sectionsDataDocs, data, filename, worksheet, newWorkbook;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                sectionFields = ['code', 'description', 'projectId', 'title', 'total'];
                sectionTitles = ['Code ', 'Description', 'Project', 'Title', 'Total'];
                linesFields = [
                    'code',
                    'description',
                    'projectId',
                    'budgetSectionId',
                    'allocation',
                    'durationRecurrence',
                    'quantity',
                    'type',
                    'unitCost',
                    'unitId',
                    'total',
                ];
                linesTitles = [
                    'Code',
                    'Description',
                    'Project',
                    'Budget Section',
                    'Allocation',
                    'Duration Recurrence',
                    'Quantity',
                    'Type',
                    'Unit Cost',
                    'Unit',
                    'Total',
                ];
                lineItemsFields = [
                    'code',
                    'budgetSectionId',
                    'budgetLineId',
                    'projectId',
                    'productName',
                    'productType',
                    'productDescription',
                    'quantity',
                    'unitCost',
                    'productUnitId',
                    'total',
                ];
                lineItemsTitles = [
                    'code',
                    'Budget Section',
                    'Budget LineId',
                    'Project',
                    'Product Name',
                    'Product Type',
                    'Product Description',
                    'Quantity',
                    'Unit Cost',
                    'Product UnitId',
                    'Total',
                ];
                return [4 /*yield*/, collectionsRef_1.budgetSectionsRef.where('projectId', '==', projectId).get()];
            case 1:
                sectionsData = _a.sent();
                return [4 /*yield*/, Promise.all(sectionsData.docs.map(function (sectionDoc) { return __awaiter(void 0, void 0, void 0, function () {
                        var sectionHeader, linesData, _a, _b;
                        var _c;
                        return __generator(this, function (_d) {
                            switch (_d.label) {
                                case 0:
                                    sectionHeader = __assign(__assign({}, (0, lodash_1.pick)(sectionDoc.data(), sectionFields)), { type: 'budgetSection' });
                                    return [4 /*yield*/, collectionsRef_1.budgetLinesRef.where('budgetSectionId', '==', sectionDoc.id).get()];
                                case 1:
                                    linesData = _d.sent();
                                    _a = [__assign({}, sectionHeader)];
                                    _c = {};
                                    _b = [[]];
                                    return [4 /*yield*/, Promise.all(linesData.docs.map(function (lineDoc) { return __awaiter(void 0, void 0, void 0, function () {
                                            var lineFieldsValues, lineItemsSN;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0:
                                                        lineFieldsValues = __assign(__assign({}, (0, lodash_1.pick)(lineDoc.data(), linesFields)), { type: 'budgetLine' });
                                                        return [4 /*yield*/, collectionsRef_1.budgetLineItemsRef.where('budgetLineId', '==', lineDoc.id).get()];
                                                    case 1:
                                                        lineItemsSN = _a.sent();
                                                        return [2 /*return*/, __assign(__assign({}, lineFieldsValues), { budgetLineItems: [
                                                                    lineItemsSN.docs.map(function (lineItemDoc) {
                                                                        return __assign(__assign({}, (0, lodash_1.pick)(lineItemDoc.data(), lineItemsFields)), { type: 'budgetLineItem' });
                                                                    }),
                                                                ] })];
                                                }
                                            });
                                        }); }))];
                                case 2: return [2 /*return*/, __assign.apply(void 0, _a.concat([(_c.budgetLines = __spreadArray.apply(void 0, _b.concat([(_d.sent()), true])), _c)]))];
                            }
                        });
                    }); }))];
            case 2:
                sectionsDataDocs = _a.sent();
                data = (0, lodash_1.flatMap)(sectionsDataDocs.map(function (section) {
                    return __spreadArray([
                        sectionTitles,
                        sectionFields.map(function (field) {
                            var _a, _b;
                            console.log({ section: section });
                            console.log({ field: field });
                            if (field === 'projectId') {
                                return (_a = projectsList_1.globalProjectsData[section[field]]) === null || _a === void 0 ? void 0 : _a.code;
                            }
                            else if (field === 'unitId') {
                                return (_b = unitsList_1.globalUnitsData[section[field]]) === null || _b === void 0 ? void 0 : _b.name;
                            }
                            else {
                                return section[field];
                            }
                        })
                    ], (0, lodash_1.flatMap)(section.budgetLines.map(function (budgetLine) {
                        return __spreadArray([
                            linesTitles,
                            linesFields.map(function (field) {
                                var _a, _b, _c;
                                if (field === 'projectId') {
                                    return (_a = projectsList_1.globalProjectsData[budgetLine[field]]) === null || _a === void 0 ? void 0 : _a.code;
                                }
                                else if (field === 'unitId') {
                                    return (_b = unitsList_1.globalUnitsData[budgetLine[field]]) === null || _b === void 0 ? void 0 : _b.name;
                                }
                                else if (field === 'budgetSectionId') {
                                    return (_c = budgetSectionsList_1.globalBudgetSectionsData[budgetLine[field]]) === null || _c === void 0 ? void 0 : _c.code;
                                }
                                else {
                                    return budgetLine[field];
                                }
                            }),
                            lineItemsTitles
                        ], budgetLine.budgetLineItems.map(function (budgetLineItem) {
                            return lineItemsFields.map(function (field) {
                                var _a, _b, _c;
                                if (field === 'projectId') {
                                    return (_a = projectsList_1.globalProjectsData[budgetLineItem[field]]) === null || _a === void 0 ? void 0 : _a.code;
                                }
                                else if (field === 'unitId') {
                                    return (_b = unitsList_1.globalUnitsData[budgetLineItem[field]]) === null || _b === void 0 ? void 0 : _b.name;
                                }
                                else if (field === 'budgetLineId') {
                                    return (_c = budgetLinesList_1.globalBudgetLinesData[budgetLineItem[field]]) === null || _c === void 0 ? void 0 : _c.code;
                                }
                                else {
                                    return budgetLineItem[field];
                                }
                            });
                        }), true);
                    })), true);
                }));
                filename = 'Budget Table';
                worksheet = xlsx_1.default.utils.aoa_to_sheet(data);
                newWorkbook = xlsx_1.default.utils.book_new();
                xlsx_1.default.utils.book_append_sheet(newWorkbook, worksheet, 'SheetJS');
                xlsx_1.default.writeFile(newWorkbook, "".concat(filename, ".xls"));
                xlsx_1.default.readFile(filename);
                return [2 /*return*/];
        }
    });
}); };
exports.exportBudgetToExcel = exportBudgetToExcel;
